import { gql } from '@apollo/client';

interface Money {
  currency: {
    code: string;
  };
  value: string;
}

export interface QueryInterface {
  currentUser: {
    balances: {
      amount: Money;
    }[];
  };
  bnh: {
    positionsSummary: {
      investmentSum: Money;
      grossUnrealizedPnlSum: Money;
    };
  };
  limited: {
    positionsSummary: {
      investmentSum: Money;
      grossUnrealizedPnlSum: Money;
    };
  };
  unlimited: {
    positionsSummary: {
      investmentSum: Money;
      grossUnrealizedPnlSum: Money;
    };
  };
  stocks: {
    positionsSummary: {
      investmentSum: Money;
      grossUnrealizedPnlSum: Money;
    };
  };
}

export default gql`
  query {
    currentUser {
      id
      balances {
        amount {
          currency {
            code
          }
          value
        }
      }
    }
    bnh {
      positionsSummary {
        grossUnrealizedPnlSum {
          value
        }
        investmentSum {
          value
        }
      }
    }
    limited {
      positionsSummary {
        grossUnrealizedPnlSum {
          value
        }
        investmentSum {
          value
        }
      }
    }
    unlimited {
      positionsSummary {
        grossUnrealizedPnlSum {
          value
        }
        investmentSum {
          value
        }
      }
    }
    stocks {
      positionsSummary {
        grossUnrealizedPnlSum {
          value
        }
        investmentSum {
          value
        }
      }
    }
  }
`;
